export default {
  sodiumDisclaimerArchorColor: Styles.color.grey.one,
  sodiumDisclaimerColor: Styles.color.grey.one,
  sodiumFill: Styles.color.grey.one,
};
